import { Box, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ITooltipInfoItem = {
  label: string
  value: string
}

type IPlanIncludesTooltipProps = {
  items: ITooltipInfoItem[]
}

export const PlanIncludesTooltip = ({ items }: IPlanIncludesTooltipProps) => {
  return (
    <Box display='flex' flexDirection='column'>
      {items.map((item, index) => (
        <Typography
          key={index}
          variant='body-md-regular'
          color='var(--content-primary-primary-inverted)'
          ariaLabel='tooltip_content_title'
          className={styles.tooltipContentTitle}
        >
          {item.label}
          <Typography
            color='var(--content-primary-tertiary-inverted)'
            ariaLabel='info_value'
            variant='body-md-regular'
          >
            {item.value}
          </Typography>
        </Typography>
      ))}
    </Box>
  )
}
